export const STEPTYPE_FORCONFIRMATION = "forConfirmation";
export const STEPTYPE_FORINFORMATION = "forInformation";
export const STEPTYPE_MAIL = "mail";

export const STEPTYPEINFORMATION = {
  requiresDueDate: (typeId: string) => {
    return (
      [STEPTYPE_FORCONFIRMATION, STEPTYPE_FORINFORMATION]
        .map((x) => x.toLowerCase())
        .indexOf(typeId.toLowerCase()) >= 0
    );
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  requiresAssignees: (typeId: string) => {
    return true;
  }
};
